import React, { Component } from "react";
//import _ from "lodash";
//import {history} from "../../store/store";
import BaseLayout from "./../../templates/base";
import Loading from "../../elements/loading";
import TracingAgreementsForm from './../../elements/tracing/agreements';

class TracingAgreements extends Component {
	render () {
		let { agreements } = this.props;
		return (
			agreements.isFetching  ? <Loading />:<TracingAgreementsForm {...this.props}/>
		)
	}

	componentWillMount() {
		let {modality,state,municipality} = this.props.match.params;
		this.props.projectAgreements(modality, state, municipality);
	}

	componentWillReceiveProps(nextprops) {
		if(nextprops.match.params !== this.props.match.params) {
			let {modality, state, municipality} = nextprops.match.params;
			this.props.projectAgreements(modality, state, municipality);
		}
	}
}

export default BaseLayout(TracingAgreements, {
	title: 'Seguimiento de Convenios',
	subnav:{
		icon: 'fa-exchange',
		name: 'Seguimientos'
	},
	stateNav: true
});


// WEBPACK FOOTER //
// ./src/layouts/tracing/agreements.jsx